import { Page, Text, View, StyleSheet, Font } from "@react-pdf/renderer";

import RobotoLight from "../../assets/fonts/Roboto/Roboto-Light.ttf";
import RobotoMedium from "../../assets/fonts/Roboto/Roboto-Medium.ttf";
import RobotoBold from "../../assets/fonts/Roboto/Roboto-Bold.ttf";
import RobotoRegular from "../../assets/fonts/Roboto/Roboto-Regular.ttf";

// Register font
Font.register({ family: "RobotoLight", src: RobotoLight });
Font.register({ family: "RobotoBold", src: RobotoBold });
Font.register({ family: "RobotoMedium", src: RobotoMedium });
Font.register({ family: "RobotoRegular", src: RobotoRegular });

const styles = StyleSheet.create({
  body: {
    padding: 20,
  },
  headerContainer: {
    marginBottom: 5,
  },
  pageTitle: {
    fontSize: 15,
    fontWeight: 600,
    fontFamily: "RobotoRegular",
    textAlign: "center",
  },
  twoColumnContainer: {
    flexDirection: "row",
    marginTop: 10,
    gap: 2,
  },
  leftColumn: {
    width: "50%",
    paddingRight: 5,
  },
  rightColumn: {
    width: "50%",
    paddingLeft: 5,
  },
  section: {
    marginBottom: 1,
  },
  sectionTitle: {
    fontSize: 9,
    fontFamily: "RobotoMedium",
    fontWeight: 600,
    marginBottom: 2,
  },
  sectionRow: {
    flexDirection: "row",
    marginBottom: 2,
    alignItems: "flex-start",
  },

  sectionRowFlex: {
    display: "flex",
    flexDirection: "column",
    marginBottom: 2,
    // alignItems: "flex-start",
    // paddingLeft: 20,
  },
  sectionTextBold: {
    fontSize: 8,
    fontFamily: "RobotoMedium",
    marginRight: 3,
    flexShrink: 0,
  },
  sectionTextBoldWithLeftMargin: {
    fontSize: 8,
    fontFamily: "RobotoMedium",
    flexShrink: 0,
  },
  sectionText: {
    fontSize: 8,
    fontFamily: "RobotoLight",
    flex: 1,
    lineHeight: 1.3,
  },

  sectionTitleWithLeftMargin: {
    fontSize: 8,
    fontFamily: "RobotoMedium",
    fontWeight: 600,
    marginBottom: 2,
    paddingLeft: 20,
  },
  sectionTextWithLeftMargin: {
    fontSize: 8,
    fontFamily: "RobotoLight",
    fontWeight: 300,
    marginBottom: 0,
    paddingLeft: 20,
  },
});

const TermsAndCondition = () => {
  return (
    <>
      <Page size="A4" wrap style={styles.body}>
        {/* Header with Envelope ID and Title */}
        <View style={styles.headerContainer}>
          <Text style={styles.pageTitle}>Terms and Conditions</Text>
        </View>

        {/* Two Column Layout */}
        <View style={styles.twoColumnContainer}>
          {/* Left Column */}
          <View style={styles.leftColumn}>
            {/* Section 1: Term */}
            <View style={styles.section}>
              <Text style={styles.sectionTitle}>1.{"  "} Term</Text>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>1.1</Text>
                <Text style={styles.sectionText}>
                  This Agreement shall take effect upon receipt of the Equipment
                  by you and shall continue for the Minimum Term and thereafter
                  for successive periods of one month (each a "Renewal Period")
                  until terminated in accordance with clause 8.
                </Text>
              </View>
            </View>
            {/* Section 2: Services to be provided by EIT */}
            <View style={styles.section}>
              <Text style={styles.sectionTitle}>
                1.{"  "} Services to be provided by EIT
              </Text>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>2.1</Text>
                <Text style={styles.sectionText}>
                  We will provide the Services and otherwise perform our
                  obligations under the Agreement: (a) in good faith and in a
                  timely and professional manner by using at all times
                  appropriately experienced, knowledgeable, qualified and
                  trained staff exercising reasonable care and skill; (b) in
                  accordance with all applicable provisions of the Agreement and
                  all laws, rules and regulations regarding the provision of the
                  Services.
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>2.2</Text>
                <Text style={styles.sectionText}>
                  The Services shall include a Call Centre Helpdesk during the
                  hours 09:00hrs to 17:00hrs Monday to Friday for the duration
                  of the Agreement, the operation of a Terminal Management
                  System for the monitoring of the Equipment to facilitate
                  application and configuration downloads and status monitoring
                  (where/when applicable). Deployment and Replacement Services
                  and Installation Services where/if requested.
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>2.3</Text>
                <Text style={styles.sectionText}>
                  The Equipment is provided at no additional cost or charge
                  other than the Charges related to the Services for the purpose
                  of carrying out Transactions and in consideration of your
                  commitment for the Minimum Term. We will supply the Equipment
                  identified on page one of the Agreement, which shall include
                  all accessories and also any additions or replacements made to
                  the Equipment) pursuant to the terms and conditions of the
                  Agreement. We retain ownership of all Equipment and may supply
                  Equipment of a different model than those stated on Page 1 of
                  the Agreement; provided that the model(s) supplied are of
                  equal specification and configuration.
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>2.4</Text>
                <Text style={styles.sectionText}>
                  We will configure the Equipment to work with your chosen
                  Acquirer services provider at the time the Equipment is
                  supplied to you, and therefore, it may not be compatible with
                  other Acquirer systems. We have no expertise or obligation to:
                  (i) conform the Equipment with that of any other Acquirer; or
                  (ii) modify or replace the Equipment to ensure its compliance
                  with industry or security standards. In the event that you
                  move to an alternative Acquirer (whether it be at your own
                  will or as a result of your Acquirer withdrawing its
                  facilities and closing your account), you will continue to be
                  bound by the Agreement irrespective of whether the Equipment
                  can be transferred to the new Acquirer's systems.
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>2.5</Text>
                <Text style={styles.sectionText}>
                  If the Equipment fails due to a manufacturing, mechanical or
                  electronic defect we will provide an equivalent replacement
                  within 24 hours, this is a target response and we do not
                  guarantee replacement within this period. You shall at all
                  times remain responsible for the Charges under the Agreement.
                  If you fail to take delivery of the replacement Equipment on
                  the confirmed delivery date we may charge you a reasonable
                  re-delivery fee, as advised at the relevant time.
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>2.6</Text>
                <Text style={styles.sectionText}>
                  We may, if we consider it necessary to do so, and for such
                  period or periods as it may deem expedient, replace the
                  Equipment with alternative Equipment of the same or similar
                  type as the original Equipment. The Equipment so substituted
                  shall then be subject to the terms and conditions of the
                  Agreement. The Equipment has been supplied to you in
                  conjunction with the Equipment configuration requested by you.
                  If you request changes to the Equipment for the provision of
                  additional facilities and we incur any related costs from the
                  Manufacturer or other third party, we will pass such costs to
                  you and collect them by direct debit.
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>2.7</Text>
                <Text style={styles.sectionText}>
                  All ownership and copyright interest in and to all computer
                  software, related documentation, technology, know-how and
                  processes embodied in or provided in connection with the
                  Equipment (collectively, the "Software") shall remain in our
                  name or our licensors, and we hereby grant to you a non-
                  exclusive license to use the Software in conjunction with its
                  operation of the Equipment.
                </Text>
              </View>
            </View>
            {/* Section 3: Site preparation */}
            <View style={styles.section}>
              <Text style={styles.sectionTitle}>3.{"  "} Site preparation</Text>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>3.1</Text>
                <Text style={styles.sectionText}>
                  You must prepare the site(s) for the Equipment in accordance
                  with our instructions.
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>3.2</Text>
                <Text style={styles.sectionText}>
                  If you arrange for the installation of the Equipment yourself,
                  you must do so in accordance with our instructions.
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>3.3</Text>
                <Text style={styles.sectionText}>
                  If you ask us to arrange for the installation of the Equipment
                  (for which an Installation Payment is payable), you must take
                  delivery of the Equipment on the confirmed installation date.
                  Failure to do so may result in a re-delivery fee.
                </Text>
              </View>
            </View>
          </View>

          {/* Right Column */}

          <View style={styles.rightColumn}>
            <View style={styles.sectionRow}>
              <Text style={styles.sectionTextBold}>3.4</Text>
              <Text style={styles.sectionText}>
                You are responsible for (a) all necessary infrastructure (power
                and telecommunications links, internet access) required to
                operate the Equipment; and (b) making your own assessment of any
                Bluetooth or other technological constraints on the site which
                may impact the operation of the Equipment.
              </Text>
            </View>
            <View style={styles.sectionRow}>
              <Text style={styles.sectionTextBold}>3.5</Text>
              <Text style={styles.sectionText}>
                We do not make or give any representation, stipulation or
                undertaking regarding the suitability of the Services for your
                business.
              </Text>
            </View>
            {/* Section 3: Site preparation */}
            <View style={styles.section}>
              <Text style={styles.sectionTitle}>
                4.{"  "} Charges payable to Nova and EIT{" "}
              </Text>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>4.1</Text>
                <Text style={styles.sectionText}>
                  You must pay the Charges in advance and in the amounts and
                  with the frequency as specified on page one of this Agreement.
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>4.2</Text>
                <Text style={styles.sectionText}>
                  The Charges will be fixed during the Minimum Term, but
                  thereafter may be subject to change by us at any time
                  following thirty (30) days' written notice.
                </Text>
              </View>
            </View>
            <View style={styles.section}>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>4.3</Text>
                <Text style={styles.sectionText}>
                  All sums payable under the Agreement are exclusive of value
                  added tax and any other taxes, charges or duties to which the
                  supply of goods or services may be subject or give rise.
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>4.4</Text>
                <Text style={styles.sectionText}>
                  If any Charges are not paid in full when due, we may charge
                  interest on such Charges at a rate of 2% per month from the
                  due date to the date of payment, such interest to be
                  compounded monthly and to run from day to day, whether before
                  or after any judgment.
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>4.5</Text>
                <Text style={styles.sectionText}>
                  The following Default Charges will apply to the Services: a)
                  Administrative charge of £20 for each direct debit, cheque or
                  other method of payment that is returned unpaid for any reason
                  b) Administrative charge of £5 for each missed payment and we
                  contact you to request payment
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>4.6</Text>
                <Text style={styles.sectionText}>
                  You may not withhold payment of any sum by reason of any
                  set-off of any claim or dispute with us whether relating to
                  the quality or performance of the Services or otherwise.
                </Text>
              </View>
            </View>
            {/* Section 3: Site preparation */}
            <View style={styles.section}>
              <Text style={styles.sectionTitle}>
                5.{"  "} Your obligations to Nova and EIT{" "}
              </Text>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>{"      "}</Text>
                <Text style={styles.sectionText}>
                  You must: (a) obtain all permits and comply with all laws,
                  rules and regulations relating to your use of Services; (b)
                  ensure that the Equipment are operated by competent and
                  qualified personnel in accordance with all relevant operating
                  instructions; (c) maintain the Equipment in good operating
                  condition (fair wear and tear accepted); (d) not permit any
                  physical alteration or modification of the Equipment or change
                  the site of the Equipment, in each case without our prior
                  written consent; (e) not create, incur, assume or allow to
                  exist any consensually or judicially imposed liens or
                  encumbrances on, or part with possession of, or sublease the
                  Equipment without our prior written consent; (f) not tamper
                  with labels or stencils on the Equipment evidencing our
                  ownership; and (g) permit us or our representatives to enter
                  your premises during normal business hours or otherwise for
                  purposes of inspecting, testing or repairing the Equipment.
                </Text>
              </View>
            </View>
            <View style={styles.section}>
              <Text style={styles.sectionTitle}>
                6.{"  "} Warranties and limits of liability{" "}
              </Text>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>6.1</Text>
                <Text style={styles.sectionText}>
                  Subject to clause 6.3, the total liability of the Service
                  Provider/Supplier of Services to you or vice versa under or in
                  connection with the Agreement in respect of the year in which
                  the liability arises, whether arising in negligence, contract
                  or otherwise, will in no event exceed the lesser of either:
                  (i) the aggregate amount of the Charges paid and payable by
                  you to us under the Agreement during the twelve (12) months
                  immediately prior to the date on which the cause of action
                  first arose; or (ii) £25,000.
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>6.2</Text>
                <Text style={styles.sectionText}>
                  Subject to clause 6.3, neither the Service Provider/Supplier
                  of Services nor you will be liable (whether in negligence,
                  contract or otherwise) for any loss of profits, income,
                  revenue, business, reputation or goodwill, loss of data,
                  opportunity or any type of special, indirect or consequential
                  loss, even if such loss was reasonably foreseeable or such
                  party has been advised of the possibility of incurring the
                  same.
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>6.3</Text>
                <Text style={styles.sectionText}>
                  Nothing in the Agreement excludes or limits the liability of
                  the Service Provider/Supplier of Services or you for: (a)
                  death or personal injury caused by its negligence; (b) breach
                  of any obligation regarding title implied by Section 7 of the
                  Supply of Goods and Services Act 1982; (c) fraud or fraudulent
                  misrepresentation; or (d) any other liability which cannot be
                  excluded by law.
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>6.4</Text>
                <Text style={styles.sectionText}>
                  Except as expressly provided in the Agreement, all conditions,
                  warranties or other terms which might have effect between the
                  parties or be implied or incorporated into the Agreement or
                  any collateral contract, whether by statute, common law or
                  otherwise, are hereby excluded.
                </Text>
              </View>
              <View style={styles.section}>
                <Text style={styles.sectionTitle}>
                  7.{"  "} Indemnity to EIT and Nova{" "}
                </Text>
                <View style={styles.sectionRow}>
                  <Text style={styles.sectionTextBold}>{"      "}</Text>
                  <Text style={styles.sectionText}>
                    You will fully indemnify and hold us harmless from and
                    against any and all losses, liabilities, damages and
                    expenses (including legal fees) which we
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </View>
      </Page>
      <Page size="A4" wrap style={styles.body}>
        <View style={styles.twoColumnContainer}>
          <View style={styles.leftColumn}>
            <View style={styles.section}>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>{"      "}</Text>
                <Text style={styles.sectionText}>
                  ncur as a result of or in connection with: (a) any breach by
                  you of any of your obligations under the Agreement, except to
                  the extent any losses, liabilities, damages or expenses result
                  from our negligence or willful misconduct; (b) the enforcement
                  of any provision of the Agreement or recovery of any payment
                  due under the Agreement by us; (c) any damage to and/or
                  malfunction of the equipment whilst in your possession other
                  any defect listed under clause 2.5; (d) our collection or
                  recovery of the Equipment.
                </Text>
              </View>
            </View>
            <View style={styles.section}>
              <Text style={styles.sectionTitle}>
                8.{"  "} Suspension and termination by Nova or EIT{" "}
              </Text>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>8.1</Text>
                <Text style={styles.sectionText}>
                  We may at any time immediately suspend your right to access or
                  use any part or all of the Services, without liability to you
                  and in addition to any other rights and remedies we may have,
                  if any Charges are overdue and outstanding by you. Once the
                  overdue Charges have been paid, we may arrange for the
                  Services to be reconnected, and a reconnection fee may be
                  payable by you.
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>8.2</Text>
                <Text style={styles.sectionText}>
                  f you terminate the Agreement before the end of the Minimum
                  Term and this is not due to reasons related to fault or
                  misconduct of us, you must pay the Termination Payment as
                  calculated and outlined in this Agreement. During the Renewal
                  Term this Agreement may be terminated by either party upon
                  serving thirty (30) days written notice to the other.
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>8.3</Text>
                <Text style={styles.sectionText}>
                  We may terminate the Agreement with immediate effect at any
                  time by written notice to you if: (a) you fail to pay any
                  Charges within 10 days of the due date; (b) you commit a
                  material breach of any term of the Agreement and such breach
                  is not capable of remedy or, if capable of remedy, you fail to
                  remedy the breach within a period of thirty (30) days of being
                  notified in writing to do so; (c) a bankruptcy order is made
                  against you or you petition for your own bankruptcy or (in
                  Scotland) a petition is presented for the sequestration of
                  your estate or you become apparently insolvent or grant a
                  trust deed for creditors; (d) you make any composition scheme
                  or arrangement with creditors or call a meeting of creditors
                  or otherwise are unable to pay your debts when due; (e) (if
                  you are a limited company) an application is made for the
                  appointment of an administrator or if a receiver is appointed
                  in respect of your assets or any part thereof or if you enter
                  into liquidation except a voluntary liquidation for the
                  purpose of amalgamation or reconstruction on terms previously
                  approved in writing by us; or (f) (if you are a partnership)
                  the partnership is dissolved.
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>8.4</Text>
                <Text style={styles.sectionText}>
                  The expiry or termination of the Agreement for any reason will
                  not prejudice or affect the accrued rights, remedies,
                  obligations or liabilities of the parties existing at
                  termination.
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>8.5</Text>
                <Text style={styles.sectionText}>
                  Upon the expiry or termination of the Agreement for any
                  reason: (a) any and all amounts outstanding and any unpaid
                  amounts due and owed under the Agreement will become
                  immediately due and payable; (b) you must at your expense
                  de-install and return to us or our agents (as notified to you)
                  at an address nominated by us no later than the tenth (10th)
                  business day after the date of expiry or termination of the
                  Agreement (with insurance and freight pre-paid) all of the
                  Equipment (together with any instruction manuals, technical
                  specifications, operating software and service, maintenance
                  and repairs records), clean, with all markings removed and all
                  missing parts replaced in good condition (fair wear and tear
                  excepted) and operating order and free from cracks, dents,
                  scratches and stains; and (c) neither party will have any
                  further right or obligation with respect to the other party
                  except as set out in this clause 8 and in the following
                  additional clauses which will continue with full force and
                  effect: clause 6 (Warranties and limits of liability), clause
                  6.4 (Indemnity) and clause 10 (General).
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>8.6</Text>
                <Text style={styles.sectionText}>
                  If you fail to return the Equipment in accordance with clause
                  8.5(b), we will charge you an amount equal to the cost of any
                  repairs or improvements to the Equipment, to restore them to
                  good working condition or the full replacement value of each
                  item of Equipment, as appropriate.
                </Text>
              </View>
              <View style={styles.section}>
                <Text style={styles.sectionTitle}>9.{"  "} Assignment </Text>
                <View style={styles.sectionRow}>
                  <Text style={styles.sectionTextBold}>9.1</Text>
                  <Text style={styles.sectionText}>
                    You must not assign or transfer the Agreement without our
                    prior written consent. We reserve the right to charge an
                    administrative fee for processing your assignment request.
                    For the purposes of the Agreement, any transfer of voting
                    control of you or your parent, and the merger of you into
                    another entity, will be considered an assignment or transfer
                    of the Agreement.
                  </Text>
                </View>
                <View style={styles.sectionRow}>
                  <Text style={styles.sectionTextBold}>9.2</Text>
                  <Text style={styles.sectionText}>
                    We may assign our rights under the Agreement to Nova
                    Connect(UK) Ltd; any payments due under this Agreement that
                    are made to Nova Connect(UK) Ltd shall satisfy and discharge
                    your obligation to make payment to us in respect of that
                    payment. We will remain liable to you for our obligations in
                    this Agreement notwithstanding the assignment of our rights
                    to Nova Connect(UK) Ltd.
                  </Text>
                </View>
              </View>
              <View style={styles.section}>
                <Text style={styles.sectionTitle}>10.{"  "} General </Text>
                <View style={styles.sectionRow}>
                  <Text style={styles.sectionTextBold}>10.1</Text>
                  <Text style={styles.sectionText}>
                    The Agreement may only be varied by a written agreement
                    signed by all parties.
                  </Text>
                </View>
              </View>
            </View>
          </View>
          <View style={styles.rightColumn}>
            <View style={styles.section}>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>10.2</Text>
                <Text style={styles.sectionText}>
                  All notices must be in writing, and will be given: (a) if sent
                  by post or e- mail, when received, and (b) if sent by courier,
                  when delivered; if to you at the address identified on page
                  one of the Agreement, and if to us at the address specified on
                  page one of the Agreement for the attention of Nova
                  Connect(UK) Ltd Limited. You agree to the receipt of arrears
                  and default notices via email to the specified email address
                  on page one of the Agreement. You must immediately notify us
                  of any changes in your postal or e-mail address.
                  Acknowledgement of the receipt of notices by either party must
                  be sent by email.
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>10.3</Text>
                <Text style={styles.sectionText}>
                  Our waiver of any breach of the Agreement by you will not
                  operate as a waiver of subsequent or other earlier breaches of
                  the same or a different kind. No failure or delay by us to
                  exercise any of our rights under the Agreement will constitute
                  a waiver of such rights.
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>10.4</Text>
                <Text style={styles.sectionText}>
                  No third party will have any rights under, or be able to
                  enforce, the Agreement.
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>10.5</Text>
                <Text style={styles.sectionText}>
                  If any provision of the Agreement is found to be invalid,
                  unenforceable or illegal, then such provision will be severed
                  and the remainder of the Agreement will continue with full
                  force and effect.
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>10.6</Text>
                <Text style={styles.sectionText}>
                  The Agreement constitutes the entire agreement between the
                  parties and supersedes all previous agreements between the
                  parties relating to its subject matter. Each party
                  acknowledges that it has not relied on any oral or written
                  representations made to it (whether made negligently or
                  innocently) other than as expressly set out in the Agreement.
                  Nothing in this clause 10.6 will limit or exclude any
                  liability for fraud.
                </Text>
              </View>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>10.7</Text>
                <Text style={styles.sectionText}>
                  The Agreement is governed by English law. The parties
                  irrevocably submit to the exclusive jurisdiction of the courts
                  of England regarding any dispute or claim arising out of or in
                  connection with the Agreement or its subject matter or
                  formation (including non-contractual disputes or claims).
                </Text>
              </View>
            </View>

            <View style={styles.section}>
              <Text style={styles.sectionTitle}>11.{"  "} Definitions </Text>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextBold}>{"         "}</Text>
                <Text style={styles.sectionText}>
                  In this Agreement, unless the context otherwise requires, the
                  following words have the following meanings:
                </Text>
              </View>
            </View>
            <View style={styles.section}>
              <Text style={styles.sectionTitleWithLeftMargin}>Acquirer </Text>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextWithLeftMargin}>
                  means the entity which processes your Transactions.
                </Text>
              </View>
            </View>
            <View style={styles.section}>
              <Text style={styles.sectionTitleWithLeftMargin}>Agreement </Text>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextWithLeftMargin}>
                  means this services agreement.
                </Text>
              </View>
            </View>
            <View style={styles.section}>
              <Text style={styles.sectionTitleWithLeftMargin}>BINs </Text>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextWithLeftMargin}>
                  s mean “bank identification numbers”; these are the range of
                  card numbers for a financial institution.
                </Text>
              </View>
            </View>
            <View style={styles.section}>
              <Text style={styles.sectionTitleWithLeftMargin}>
                Call Centre Help Desk{" "}
              </Text>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextWithLeftMargin}>
                  means support for point of sale terminals.
                </Text>
              </View>
            </View>
            <View style={styles.section}>
              <Text style={styles.sectionTitleWithLeftMargin}>Charges </Text>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextWithLeftMargin}>
                  means the Monthly Payment and if applicable the Installation
                  Payment.
                </Text>
              </View>
            </View>
            <View style={styles.section}>
              <Text style={styles.sectionTitleWithLeftMargin}>
                Deployment & Replacement Services{" "}
              </Text>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextWithLeftMargin}>
                  means the shipping of the Equipment to the merchant location
                  and replacement services that fall under the warranty.
                </Text>
              </View>
            </View>
            <View style={styles.section}>
              <Text style={styles.sectionTitleWithLeftMargin}>Equipment </Text>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextWithLeftMargin}>
                  means the point of sale devices described in the front sheet
                  and provided as part of the Services including all accessories
                  and any replacements.
                </Text>
              </View>
            </View>
            <View style={styles.section}>
              <Text style={styles.sectionTitleWithLeftMargin}>
                Installation Payment{" "}
              </Text>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextWithLeftMargin}>
                  means the one-off payment due for the Installation Services
                </Text>
              </View>
            </View>
            <View style={styles.section}>
              <Text style={styles.sectionTitleWithLeftMargin}>
                Installation Services{" "}
              </Text>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextWithLeftMargin}>
                  s means the use of an engineer to setup the terminal on the
                  merchant’s premises for the first time (where applicable).
                </Text>
              </View>
            </View>
            <View style={styles.section}>
              <Text style={styles.sectionTitleWithLeftMargin}>
                Minimum Term{" "}
              </Text>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextWithLeftMargin}>
                  means the minimum period (usually in months) for which the
                  Services will be provided as set out on page one of this
                  Agreement.
                </Text>
              </View>
            </View>
            <View style={styles.section}>
              <Text style={styles.sectionTitleWithLeftMargin}>
                Monthly Payment{" "}
              </Text>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextWithLeftMargin}>
                  means the payments calculated and due each month for the
                  Services.
                </Text>
              </View>
            </View>
            <View style={styles.section}>
              <Text style={styles.sectionTitleWithLeftMargin}>Services </Text>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextWithLeftMargin}>
                  means the Call Centre Helpdesk, Deployment & Replacement and
                  if applicable the Installation Services.
                </Text>
              </View>
            </View>
            <View style={styles.section}>
              <Text style={styles.sectionTitleWithLeftMargin}>
                Renewal Term{" "}
              </Text>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextWithLeftMargin}>
                  means the month to month period after the Minimum Term during
                  which the Services are provided under the terms of this
                  Agreement
                </Text>
              </View>
            </View>
            <View style={styles.section}>
              <Text style={styles.sectionTitleWithLeftMargin}>
                Terminal Management System{" "}
              </Text>
              <View style={styles.sectionRow}>
                <Text style={styles.sectionTextWithLeftMargin}>
                  means the terminal estate management system that allows for
                  the configuration of terminal parameters, BINS, card
                  processing rules and remote software downloads.
                </Text>
              </View>
            </View>
          </View>
        </View>
      </Page>
      <Page size="A4" wrap style={styles.body}>
        <View style={styles.headerContainer}>
          <View style={styles.twoColumnContainer}>
            <View style={styles.leftColumn}>
              <View style={styles.section}>
                <Text
                  style={[
                    styles.sectionTitleWithLeftMargin,
                    { paddingLeft: 0 },
                  ]}
                >
                  Termination Payment
                </Text>
                <View style={styles.sectionRow}>
                  <Text
                    style={[
                      styles.sectionTextWithLeftMargin,
                      { paddingLeft: 0 },
                    ]}
                  >
                    means an amount equal to all the remaining Monthly Payments
                    for the remainder of the Term and any Charges due and unpaid
                    at the date of termination.
                  </Text>
                </View>
              </View>
              <View style={styles.section}>
                <Text
                  style={[
                    styles.sectionTitleWithLeftMargin,
                    { paddingLeft: 0 },
                  ]}
                >
                  Transaction
                </Text>
                <View style={styles.sectionRow}>
                  <Text
                    style={[
                      styles.sectionTextWithLeftMargin,
                      { paddingLeft: 0 },
                    ]}
                  >
                    means the purchase or lease by a cardholder of goods and/or
                    services from you (including a credit or refund) by use of a
                    card and/or any cardholder obtaining a cash advance from
                    you.
                  </Text>
                </View>
              </View>
              <View style={styles.section}>
                <Text
                  style={[
                    styles.sectionTitleWithLeftMargin,
                    { paddingLeft: 0 },
                  ]}
                >
                  We, Our, Us
                </Text>
                <View style={styles.sectionRow}>
                  <Text
                    style={[
                      styles.sectionTextWithLeftMargin,
                      { paddingLeft: 0 },
                    ]}
                  >
                    means Nova Connect(UK) Ltd Limited and/or EIT and any
                    persons to whom our rights have been assigned or to whom our
                    rights and responsibilities under the Agreement have passed
                    by assignment or transfer.
                  </Text>
                </View>
              </View>
              <View style={styles.section}>
                <Text
                  style={[
                    styles.sectionTitleWithLeftMargin,
                    { paddingLeft: 0 },
                  ]}
                >
                  You, Your
                </Text>
                <View style={styles.sectionRow}>
                  <Text
                    style={[
                      styles.sectionTextWithLeftMargin,
                      { paddingLeft: 0 },
                    ]}
                  >
                    means the merchant which enters into the Agreement. In
                    interpreting the Agreement (unless the context requires
                    otherwise) any reference to any statute or statutory
                    provision including any subordinate legislation includes a
                    reference to that statute or statutory provision as from
                    time to time amended, extended, re-enacted and/or replaced.
                  </Text>
                </View>
              </View>
              <View style={styles.section}>
                <Text
                  style={[
                    styles.sectionTitleWithLeftMargin,
                    { paddingLeft: 0 },
                  ]}
                >
                  Use of Information
                </Text>
                <View style={styles.sectionRowFlex}>
                  <Text
                    style={[
                      styles.sectionTextWithLeftMargin,
                      { paddingLeft: 0 },
                    ]}
                  >
                    In order to complete the application process we will require
                    you to provide us with certain information which is
                    considered personal data under the Data Protection Act 2018
                    (the "Act"). For the purposes of the Act, we shall be
                    considered a data controller of this personal data. Us will
                    process personal data for the following purposes to: (i)
                    process this Agreement; (ii) assess applications for credit
                    and other products and services that you require; (iii)
                    manage your account and provide services to you; (iv)
                    conduct, monitor and analyse our business; (v) contact you
                    (unless You tells us that you prefer not to be contacted)
                    about products and services including those of carefully
                    selected third parties which may interest you; (vi) recover
                    debts and prevent fraud; and (vii) comply with applicable
                    law and regulations. We may sometimes use a credit scoring
                    or other automated decision making system when processing
                    the information, including personal data, provided.
                  </Text>
                  <Text
                    style={[
                      styles.sectionTextWithLeftMargin,
                      { paddingLeft: 0 },
                    ]}
                  >
                    We may disclose and transfer personal data to other
                    companies within our group, other persons who provide a
                    service to us, or to our employees, agents, associated
                    companies, insurers or anyone to whom we propose to transfer
                    any of our rights and/or responsibilities under this
                    Agreement, each of whom may also use the personal data in
                    the ways described in this Agreement. We may also disclose
                    any information, including personal data that you provide
                    to: (i) anyone to whom you authorise us to give such
                    information; and (ii) comply with any legal or regulatory
                    requirements on us or any company within our group.
                  </Text>
                  <Text
                    style={[
                      styles.sectionTextWithLeftMargin,
                      { paddingLeft: 0 },
                    ]}
                  >
                    In order to use and disclose personal data for the purposes
                    set out above we may transfer the personal data to our
                    affiliated companies outside the European Economic Area,
                    including the United States of America, which may not have
                    laws comparable to those in the European Union to protect
                    such personal data.
                  </Text>
                  <Text
                    style={[
                      styles.sectionTextWithLeftMargin,
                      { paddingLeft: 0 },
                    ]}
                  >
                    We or our agents may monitor or record telephone calls or
                    other forms of communication from you or your employees or
                    agents to ensure instructions are carried out correctly and
                    to help improve the quality of the service.
                  </Text>
                </View>
              </View>
              <View style={styles.section}>
                <Text
                  style={[
                    styles.sectionTitleWithLeftMargin,
                    { paddingLeft: 0 },
                  ]}
                >
                  Credit Reference and Fraud Prevention{" "}
                </Text>
                <View style={styles.sectionRowFlex}>
                  <Text
                    style={[
                      styles.sectionTextWithLeftMargin,
                      { paddingLeft: 0 },
                    ]}
                  >
                    We shall be entitled to conduct any search we deem necessary
                    with any credit reference or fraud prevention agency, as
                    well as searches of the Electoral Register in order to: (i)
                    manage your account; (ii) verify your credit history and
                    take decisions about credit; and (iii) protect against money
                    laundering. This authorisation will remain in place during
                    the term of this Agreement.
                  </Text>
                  <Text
                    style={[
                      styles.sectionTextWithLeftMargin,
                      { paddingLeft: 0 },
                    ]}
                  >
                    If you give false or inaccurate information and we suspect
                    fraud, we will record this. We may keep any information
                    provided by you or about this Agreement in its records and
                    may disclose this information and information relating to
                    you and held by other companies within our group to credit
                    reference and fraud prevention agencies. If you do not pay
                    the fees in full and on time, we may tell credit reference
                    agencies who will record the outstanding debt.
                  </Text>
                  <Text
                    style={[
                      styles.sectionTextWithLeftMargin,
                      { paddingLeft: 0 },
                    ]}
                  >
                    A credit reference or fraud prevention agency contacted by
                    us in connection with this Agreement may keep a record of
                    our inquiry, which will be available to later inquirers. The
                    credit reference and fraud prevention agencies will share
                    the search details and account information with us and other
                    organisations so that we and they might: (i) assess
                    applications for credit and related services and manage
                    accounts; (ii) check your identity to prevent money
                    laundering; (iii) prevent, detect or prosecute fraud or
                    other crimes; (iv) recover and trace debts; and (v)
                    undertake statistical analysis. Please write to us at the
                    address specified on page one of this Agreement to the
                    attention of The Data Protection Officer if you would like
                    details of the credit reference and fraud prevention
                    agencies.
                  </Text>
                </View>
              </View>
              <View style={styles.section}>
                <Text
                  style={[
                    styles.sectionTitleWithLeftMargin,
                    { paddingLeft: 0 },
                  ]}
                >
                  Personal data of other persons
                </Text>
                <View style={styles.sectionRow}>
                  <Text
                    style={[
                      styles.sectionTextWithLeftMargin,
                      { paddingLeft: 0 },
                    ]}
                  >
                    By including personal information about other persons in
                    this Agreement you confirm that you have the consent of and
                    are entitled to disclose such information and that each such
                    person has consented to the use and disclosure of their
                    personal data for the purposes and in the ways described in
                    this Agreement. Where information about other persons is
                    provided in or in connection with this Agreement, you and
                    each such person understands that an "association" will be
                    created at the credit reference agencies, which will link
                    their financial records. Credit searches and other
                    information which is provided to us and/or the credit
                    reference agencies, about you and those with whom you are
                    linked financially may be used by us and other companies if
                    credit decisions are made about you, or other members of
                    your household.
                  </Text>
                </View>
              </View>
            </View>
            <View style={styles.rightColumn}>
              <View style={styles.section}>
                <Text
                  style={[
                    styles.sectionTitleWithLeftMargin,
                  ]}
                >
                  Rights to personal data
                </Text>
                <View style={styles.sectionRow}>
                  <Text
                    style={[
                      styles.sectionTextWithLeftMargin,
                    ]}
                  >
                    Individuals have a right to a copy of the personal
                    information we holds about them. If you or other persons
                    wish to exercise this right they should apply in writing to
                    us at the address specified on page one of this Agreement to
                    the attention of The Data Protection Officer. A fee will be
                    payable.
                  </Text>
                </View>
              </View>
              <View style={styles.section}>
                <Text
                  style={[
                    styles.sectionTitleWithLeftMargin,
                  ]}
                >
                  Marketing
                </Text>
                <View style={styles.sectionRow}>
                  <Text
                    style={[
                      styles.sectionTextWithLeftMargin,
                    ]}
                  >
                    We may use your information to contact you from time to time
                    about our services or products and/or services or products
                    from companies within our group and/or from other carefully
                    selected third parties. If You DO NOT want us to contact you
                    for these purposes by the following means then tick the
                    relevant box: By telephone  By post/email  SMS .
                  </Text>
                </View>
              </View>
              <View style={styles.section}>
                <Text
                  style={[
                    styles.sectionTitleWithLeftMargin,
                  ]}
                >
                  Consent to use personal data
                </Text>
                <View style={styles.sectionRow}>
                  <Text
                    style={[
                      styles.sectionTextWithLeftMargin,
                    ]}
                  >
                    By signing this Agreement you consent to our use and
                    disclosure of your personal data and the personal data of
                    any other persons specified above in the ways described in
                    this Agreement and confirm the information given is true and
                    complete.
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </>
  );
};

export default TermsAndCondition;
